import { useParams } from "react-router-dom";
import EditUserForm from "./EditUserForm";
import { useGetUsersQuery } from "./usersApiSlice";
import PulseLoader from "react-spinners/PulseLoader";
import useTitle from "../../hooks/useTitle";
import { useMemo } from "react";

// const EditUser = () => {
//   useTitle("Izmeni korisnika");

//   const { id } = useParams();

//   const { user } = useGetUsersQuery("usersList", {
//     selectFromResult: ({ data }) => ({
//       user: data?.entities[id],
//     }),
//   });

//   if (!user) return <PulseLoader color={"#FFF"} />;

//   const content = <EditUserForm user={user} />;

//   return content;
// };

//Kao optimizovanije
const EditUser = () => {
  useTitle("Izmeni korisnika");
  const { id } = useParams();
  const { data, isLoading, isFetching } = useGetUsersQuery("usersList");

  const user = useMemo(() => data?.entities[id], [data, id]);

  if (isLoading || isFetching) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <PulseLoader color={"#FFF"} />
        <p className="mt-4 text-white">Učitavanje korisničkih podataka...</p>
      </div>
    );
  }

  if (!user) {
    return <p className="text-red-500 text-center">Korisnik nije pronađen.</p>;
  }

  return <EditUserForm user={user} />;
};
export default EditUser;
